module.exports = __webpack_public_path__ + "img/cellphone-line.c3826a07.svg";